<template>
  <div class="adp-sidebar-container">
    <template v-if="loading">
      {{ $t('voc.loading') }}
    </template>

    <template v-if="!loading && sideBarOpened" >
      <div class="adp-subtitle">
        <span class="adp-h3">{{ $t('idp.employees') }} </span>
        <span class="adp-h3 adp-h3__green adp-h3__clickable" @click="$bvModal.show('org-tree-employee-search-modal');">{{ items.length }} {{ $tc('idp.men', items.length) }}</span>
        <div style="position: relative; display: inline">
          <button class="btn adp-btn" style="margin: 0 1.5rem 0 2rem" @click="showContextMenu()">
            {{ $t('voc.actions') }}
          </button>
          <div class="actions-button-error" v-if="showError" v-click-outside="() => {showError = false}">
            {{ $t('voc.warning_actions_employee') }}
          </div>
        </div>
        <div class="adp-task--crud-actions" v-if="contextMenu.isVisible && selectedItemsStatuses.length" :style="cmStyles"
             v-click-outside="() => hideContextMenu()" ref="actions">
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" v-if="canAssignActivity()"
               @click="assignActivities()">
            {{ $t('idp.assign_idp') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" v-if="canAssignNotAssignedActivity()"
               @click="assignNotAssignActivities()">
            {{ $t('idp.assign_not_assigned') }}
          </div>
          <a class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin"
             :href="`/catalog?pernumbers=${Object.keys(assignItems).join()}`">
            {{ $t('idp.add_learning_from_catalog') }}

          </a>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" v-if="canChangeIdpStatus()"
               @click="changeIdpStatus()">
            {{ $t('idp.change_learning_status') }}
          </div>
          <div class="btn adp-btn adp-btn__t-left adp-btn__light adp-p__margin" @click="loadFiles()">
            {{ $t('idp.load_files') }}
          </div>
        </div>

        <div class="adp-report" style="display: inline-block;">
          <img src="/images/rectangle-yellow.svg" style="height: 35px">
          <img src="/images/download.svg" class="adp-report__download-list">
        </div>
      </div>

      <div class="adp-grid-table">
        <div class="adp-grid-row">
          <div class="adp-grid-cell adp-grid-cell__chbox">
            <b-form-checkbox v-model="selectAll" :indeterminate="selectAllIndeterminate" @change="selectAllHandler($event)">&nbsp;</b-form-checkbox>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingPernumber !== null}" @click="sortChange('sortingPernumber')">
              {{ $t('voc.table_id') }} <img :src="getSortingIcon(sortingPernumber)" alt="sort">
            </span>
            <input @input="filterEmployee" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterPernumber">
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingName !== null}" @click="sortChange('sortingName')">
              {{ $t('voc.table_fullname') }} <img :src="getSortingIcon(sortingName)" alt="sort">
            </span>
            <input @input="filterEmployee" type="text" class="adp-input adp-input__catalog adp-input-search" v-model="filterName">
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingPosition !== null}" @click="sortChange('sortingPosition')">
              {{ $t('voc.table_position') }} <img :src="getSortingIcon(sortingPosition)" alt="sort">
            </span>
            <my-dropdown :options="positions" :init-selected="filterPosition" :has-select-all="true" :localize="false"
                         v-on:my-change="onDropdownUpdate($event, 'filterPosition')">
            </my-dropdown>
          </div>
          <div class="d-flex flex-column adp-grid-cell__head">
            <span class="adp-th adp-th__sort" :class="{'adp-th__active': sortingStatus !== null}" @click="sortChange('sortingStatus')">
              {{ $t('voc.table_status_idp') }} <img :src="getSortingIcon(sortingStatus)" alt="sort">
            </span>
            <my-dropdown :options="IDPStatuses" :init-selected="filterStatus" :has-select-all="true"
                         v-on:my-change="onDropdownUpdate($event, 'filterStatus')">
            </my-dropdown>
          </div>
        </div>
        <div style="cursor: pointer" class="adp-grid-row" v-for="(item, i) in items" :key="i" v-if="employees"
            :class="{'adp-filter-list-item__active': $route.params.pernumber === item.pernumber,
            'adp-grid-row__warning': item.has_expired_activities && item.status === 'agreed_by_hr'}">
          <div class="adp-grid-cell adp-grid-cell__chbox-hr">
            <b-form-checkbox v-model="item.is_checked" @change="selectEvent" @click.stop/>
          </div>
          <div class="adp-grid-cell adp-grid-cell__code" @click="viewSelectedEmployee(item.pernumber)">
            {{ item.pernumber }}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title" @click="viewSelectedEmployee(item.pernumber)">
            {{item.fullname}}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title" @click="viewSelectedEmployee(item.pernumber)">
            {{item.position}}
          </div>
          <div class="adp-grid-cell adp-grid-cell__title"
               :class="{'adp-grid-cell__title-green': item.status === 'agreed_by_hr',
                        'adp-grid-cell__title-red': item.status === 'not_formed' || item.status === 'on_approval'}"
               @click="viewSelectedEmployee(item.pernumber)">
            <div v-if="item.has_expired_activities && item.status === 'agreed_by_hr'" style="position: relative">
              {{ item.status === 'on_approval' ? $t(`idp.on_approval_hr`) : $t(`idp.${item.status}`) }}
              <div style="color: #E02020; font-size: 12px" v-if="item.has_expired_activities && item.status === 'agreed_by_hr'">
                {{ $t('idp.has_expired_activities') }}
              </div>
              <img src="/images/expired-activity.svg" style="position: absolute;left: 211px;top: 11px;height: 20px">
            </div>
            <div v-else>
              {{ item.status === 'on_approval' ? $t(`idp.on_approval_hr`) : $t(`idp.${item.status}`) }}
              <div style="color: #E6C600; font-size: 12px" v-if="item.has_inconsistent_activities && item.status === 'agreed_by_hr'">
                {{ $t('idp.has_inconsistent_activities') }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <org-tree-employee-search-modal v-on:apply-filter="updateFilterStructure" />
      <mass-draft-approval-modal :employees-props="assignItems" v-on:update-idp-activities="onIDPActivitiesUpdate" />
      <mass-change-status-modal :employees-props="assignItems" v-on:mass-change-status="onMassChangeStatus" />
      <mass-attach-files-modal :employees-props="assignItems" v-on:mass-attach-files="onMassAttachFiles"/>
    </template>

    <div class="adp-sidebar-close" v-if="sideBarOpened" @click="closeSidebar">
      <span class="adp-sidebar-close__text">
        {{ $t('voc.table_close_sidebar') }}
      </span>
      <span class="adp-sidebar-close__icon">
        <img src="/images/sidebar-close.svg" style="position: absolute;right: 7px;top: -1px;">
        <img src="/images/sidebar-close.svg">
      </span>
    </div>

    <div class="adp-sidebar-open" v-if="!sideBarOpened" @click="openSidebar">
      <div class="adp-sidebar-open__icon">
        <img src="/images/sidebar-open.svg" style="position: absolute; right: 18px; top: 17px;">
        <img src="/images/sidebar-open.svg" style="position: absolute; right: 25px; top: 17px;">
      </div>
      <div class="adp-sidebar-open__text">{{ $t('voc.table_open_sidebar') }}</div>
    </div>
  </div>
</template>

  <script>
  import MyIDPFilter from "./MyIDPFilter";
  import {updateUrl} from "../updateUrl";
  import MyDropdown from "./MyDropdown";
  import OrgTreeEmployeeSearchModal from "./modals/OrgTreeEmployeeSearchModal";
  import MassDraftApprovalModal from "./modals/MassDraftApprovalModal";
  import MassChangeStatusModal from "./modals/MassChangeStatusModal";
  import MassAttachFilesModal from "./modals/MassAttachFilesModal";
  import api from "../api";
  import Vue from "vue";

  export default {
    name: "EmployeeSearch",
    components: {
      'my-idp-filter': MyIDPFilter,
      'my-dropdown': MyDropdown,
      'org-tree-employee-search-modal': OrgTreeEmployeeSearchModal,
      'mass-draft-approval-modal': MassDraftApprovalModal,
      'mass-change-status-modal': MassChangeStatusModal,
      'mass-attach-files-modal': MassAttachFilesModal,
    },
    data: function () {
      return {
        showError: false,

        loading: true,
        selectAll: false,
        selectAllIndeterminate: false,
        sideBarOpened: false,

        role: this.$role,

        employees: [],
        items: [],
        assignItems: {},

        sortingPernumber: null,
        sortingName: null,
        sortingPosition: null,
        sortingStatus: null,

        filterPernumber: '',
        filterName: '',
        filterPosition: [],
        filterStatus: [],
        filterStructure: [],

        positions: [],
        IDPStatuses: [],

        contextMenu: {
          isVisible: false,
          left: 0,
        },
        selectedItemsStatuses: [],
        selectedItemsExpire: [],
        selectedItemsInconsistent: [],
        currentYear: 0,
      }
    },
    computed: {
      cmStyles() {
        return {
          top: '85px',
          left: `${this.contextMenu.left}px`,
          right: 'unset',
        };
      },
    },
    watch: {
      filterPernumber(newVal) {
        this.updateUrl({filterPernumber: newVal && newVal.length ? String(newVal) : null});
      },
      filterName(newVal) {
        this.updateUrl({filterName: newVal && newVal.length ? String(newVal) : null});
      },
      filterPosition(newVal) {
        this.updateUrl({filterPosition: newVal && newVal.length ? String(newVal) : null});
      },
      filterStatus(newVal) {
        this.updateUrl({filterStatus: newVal && newVal.length ? String(newVal) : null});
      },
    },
    methods: {
      dropSortAndFiler() {
        this.filterPernumber = '';
        this.filterName = '';
        this.filterPosition = [];
        this.filterStatus = [];
        this.filterStructure = [];

        this.sortingPernumber = null;
        this.sortingName = null;
        this.sortingPosition = null;
        this.sortingStatus = null;
      },
      filterEmployee() {
        function dynamicSort(property) {
          let sortOrder = 1;
          if (property[0] === "-") {
            sortOrder = -1;
            property = property.substr(1);
          }
          return function (a, b) {
            let result = (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
            return result * sortOrder;
          }
        }

        let items = this.employees;
        if (this.filterPernumber) {
          this.filterPernumber.length > 0
            ? items = items.filter(el => String(el.pernumber).includes(String(this.filterPernumber)))
            : items = items.filter(el => el.pernumber);
        }
        if (this.filterName) {
          this.filterName.length > 0
            ? items = items.filter(el => {
              return String(el.fullname).toLowerCase().includes(this.filterName)
                || String(el.fullname).includes(this.filterName)
            })
            : items = items.filter(el => el.fullname);
        }
        if (this.filterPosition.length > 0) {
          items = items.filter(el => this.filterPosition.includes(el.position));
        }
        if (this.filterStatus.length > 0) {
          items = items.filter(el => this.filterStatus.includes(el.status));
        }
        if (this.filterStructure.length > 0) {
          items = items.filter(el => {
            return this.filterStructure.some(fsEl => {
              switch (fsEl.type) {
                case 'company':
                  return el.company === fsEl.id;
                case 'department':
                  return el.department === fsEl.id;
                case 'division':
                  return el.division === fsEl.id;
                case 'subdivision':
                  return el.subdivision === fsEl.id;
                case 'user':
                  return el.pernumber == fsEl.id;
                default:
                  return false;
              }
            });
          });
        }

        // возвращаем сортировку в исходное положение(сортируем по pernumber)
        items = items.sort(dynamicSort('pernumber'));

        if (this.sortingPernumber) {
          let co = this.sortingPernumber === 'desc' ? '-' : '';
          items = items.sort(dynamicSort(`${co}pernumber`));
        } else if (this.sortingName) {
          let co = this.sortingName === 'desc' ? '-' : '';
          items = items.sort(dynamicSort(`${co}fullname`));
        } else if (this.sortingPosition) {
          let co = this.sortingPosition === 'desc' ? '-' : '';
          items = items.sort(dynamicSort(`${co}position`));
        } else if (this.sortingStatus) {
          let co = this.sortingStatus === 'desc' ? '-' : '';
          items = items.sort(dynamicSort(`${co}status`));
        }

        items.forEach(el => el.is_checked = false);
        this.items = JSON.parse(JSON.stringify(items));
      },
      updateFilterStructure(e) {
        this.$set(this, 'filterStructure', e);
        this.filterEmployee();
      },
      updateUrl(params) {
        updateUrl(params);
      },
      async getEmployees() {
        this.loading = true;
        try {
          let resp = await axios.get('/search');
          this.employees = resp.data.data;
        } catch (e) {
          console.error(e);
        }
        this.loading = false;
        this.filterEmployee();
      },
      selectAllHandler(event) {
        if (Object.keys(this.assignItems).length) {
          this.items = this.items.map(el => {el.is_checked = false; return el});
          this.selectAll = false;
        } else {
          this.items = this.items.map(el => {el.is_checked = true; return el});
          this.selectAll = true;
        }
        this.selectAllIndeterminate = false;
        this.updateItemsChecked();
      },
      updateItemsChecked() {
        let items = {};
        let assignedItems = this.items.filter(el => el.is_checked).map(el => ({ ...el }));

        assignedItems.forEach(item => {
          items[item.pernumber] = item
        })

        this.assignItems = items;
      },
      selectEvent() {
        let checkedElementsCnt = this.items.filter(el => el.is_checked).length;
        if (this.items.length === checkedElementsCnt) {
          this.selectAll = true;
          this.selectAllIndeterminate = false;
        } else if (this.items.length > checkedElementsCnt && checkedElementsCnt > 0) {
          this.selectAll = false;
          this.selectAllIndeterminate = true;
        } else {
          this.selectAll = false;
          this.selectAllIndeterminate = false;
        }

        this.updateItemsChecked();
      },
      getSortingIcon(val) {
        if (val === null) {
          return '/images/sort.svg';
        } else if (val === 'asc') {
          return '/images/sort_active_asc.svg';
        } else if (val === 'desc') {
          return '/images/sort_active_desc.svg';
        }
      },
      sortChange(prop) {
        if (this[prop] === null) {
          this[prop] = 'asc';
        } else if (this[prop] === 'asc') {
          this[prop] = 'desc';
        } else if (this[prop] === 'desc') {
          this[prop] = null;
        }

        ['sortingPernumber', 'sortingName', 'sortingPosition', 'sortingStatus'].forEach(el => {
          if (el === prop) {
            this.updateUrl({[el]: this[prop]})
            return;
          }
          if (this[el]) {
            this[el] = null;
            this.updateUrl({[el]: null})
          }
        });

        this.filterEmployee();
      },
      onDropdownUpdate(e, property) {
        this[property] = e;
        this.filterEmployee();
      },
      closeSidebar() {
        this.sideBarOpened = false;
        this.$emit('close-sidebar');
      },
      openSidebar() {
        this.dropSortAndFiler();
        this.getEmployees();
        this.sideBarOpened = true;
        this.$emit('open-sidebar');
      },
      viewSelectedEmployee(EmployeePernumber) {
        this.$router.push({ name: `${this.role}-employee`, params: { pernumber: EmployeePernumber }, query: this.$route.query});
        this.closeSidebar();
      },
      showContextMenu() {
        if (!Object.values(this.assignItems).length) {
          this.showError = true;
          setTimeout(() => this.showError = false, 2000)
          return;
        }
        this.contextMenu.isVisible = true;

        this.selectedItemsStatuses = Object.values(this.assignItems).map(item => item.status);
        this.selectedItemsExpire = Object.values(this.assignItems).map(item => item.has_expired_activities);
        this.selectedItemsInconsistent = Object.values(this.assignItems).map(item => item.has_inconsistent_activities);

        this.$nextTick(() => {
          this.contextMenu.left = Number(event.pageX) - 50;
        });
      },
      hideContextMenu() {
        this.contextMenu.isVisible = false;
      },
      canAssignActivity() {
        const statuses = this.selectedItemsStatuses;

        if (this.role === 'hr') {
          return !(statuses.includes('not_formed') || statuses.includes('agreed_by_hr'));
        }
        if (this.role === 'manager') {
          return !(statuses.includes('not_formed') || statuses.includes('agreed_by_hr') || statuses.includes('agreed_by_manager'));
        }
      },
      canAssignNotAssignedActivity() {
        const statuses = this.selectedItemsStatuses;
        const expiredActivities = this.selectedItemsExpire.includes(true);
        const inconsistentActivities = this.selectedItemsInconsistent.includes(true);

        return inconsistentActivities && this.role === 'hr' && !(statuses.includes('not_formed') || statuses.includes('on_approval')
          || statuses.includes('agreed_by_manager') || expiredActivities);

      },
      canChangeIdpStatus() {
        const statuses = this.selectedItemsStatuses;
        return !(statuses.includes('on_approval') || statuses.includes('agreed_by_manager') || statuses.includes('not_formed'))
          && this.role === 'hr';
      },
      async assignActivities() {
        const pernumbers = Object.keys(this.assignItems);
        await pernumbers.forEach((pernumber) => {
           api.agreeIDP(this.role, pernumber)
        });

        await this.getEmployees()
        await this.$router.push('/hr/');
      },
      assignNotAssignActivities() {
        this.$bvModal.show('mass-draft-approval-modal');
      },
      async onIDPActivitiesUpdate() {
        this.$bvModal.hide('mass-draft-approval-modal')
        await this.getEmployees();
        Vue.set(this, 'assignItems', {});
        this.selectAllIndeterminate = false;
      },
      changeIdpStatus() {
        this.$bvModal.show('mass-change-status-modal');
      },
      async onMassChangeStatus() {
        this.$bvModal.hide('mass-change-status-modal')
        await this.getEmployees();
        Vue.set(this, 'assignItems', {});
        this.selectAllIndeterminate = false;
      },
      async onMassAttachFiles() {
        this.$bvModal.hide('mass-attach-files-modal')
        await this.getEmployees();
        Vue.set(this, 'assignItems', {});
        this.selectAllIndeterminate = false;
      },
      loadFiles() {
        this.$bvModal.show('mass-attach-files-modal');
      },
    },
    async mounted() {
      let idpStatusArr = window.IDP.idpStatuses;
      for (let status of idpStatusArr) {
        this.IDPStatuses.push({id: status, code: status,},)
        this.IDPStatuses.map(status => {
          if (status.id === 'on_approval') status.on_approval = true;
        });
      }

      await this.getEmployees();
      this.sideBarOpened = true;
      this.$emit('open-sidebar');

      const uniquePositions = [...new Set(this.items.map(item => item.position))];
      this.positions = uniquePositions.map(item => ({id: String(item), code: String(item)}));
    }
  }
</script>

<style scoped>

</style>
